import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { LeadType, ObjectType, TaskForType } from '@econtractor/types';
import Editor from 'components/editors/Editor';
import ProcessCategorySelect from '../../ProcessDir/ProcessCategory/ProcessCategorySelect';
import TaskFor from '../../shared/TaskFor';

interface ProcessRunGeneralFieldsProps {
    categoryId: number | null;
    name: string;
    description: string;
    showDescription: boolean;
    launched: boolean;
    disabled: boolean;
    taskFor: TaskForType;
    lead: LeadType | null;
    object: ObjectType | null;
    onCategoryChange: (categoryId: number | null) => void;
    onNameChange: (name: string) => void;
    onDescriptionChange: (description: string) => void;
    onShowDescription: () => void;
    onTaskForChange: (taskFor: TaskForType) => void;
    onLeadChange: (lead: LeadType | null) => void;
    onObjectChange: (object: ObjectType | null) => void;
}

const ProcessRunGeneralFields = ({
    categoryId,
    name,
    description,
    showDescription,
    launched,
    disabled,
    taskFor,
    lead,
    object,
    onCategoryChange,
    onNameChange,
    onDescriptionChange,
    onShowDescription,
    onTaskForChange,
    onLeadChange,
    onObjectChange,
}: ProcessRunGeneralFieldsProps) => {
    const { t } = useTranslation('Tasks');

    return (
        <>
            <TaskFor
                taskFor={taskFor}
                lead={lead}
                object={object}
                disabled={disabled}
                onTaskForChange={onTaskForChange}
                onLeadChange={onLeadChange}
                onObjectChange={onObjectChange}
            />
            <Form.Group className="mb-3">
                <label className="form-label text-muted">{t('fields.category')}</label>
                <ProcessCategorySelect
                    value={categoryId}
                    disabled={disabled}
                    onChange={(opt) => onCategoryChange(opt?.value ?? null)}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <label className="form-label text-muted">{t('processDir.labelName')}</label>
                <Form.Control
                    value={name}
                    disabled={disabled}
                    onChange={(event) => onNameChange(event.target.value)}
                />
            </Form.Group>
            {launched ? (
                showDescription ? (
                    <Form.Group className="mb-3">
                        <label className="form-label text-muted">{t('labelInfo')}</label>
                        <div className="task-card-description" dangerouslySetInnerHTML={{ __html: description }} />
                    </Form.Group>
                ) : null
            ) : (
                <Form.Group className="mb-3">
                    {showDescription ? (
                        <>
                            <label className="form-label text-muted">{t('labelInfo')}</label>
                            <Editor value={description || ''} onChange={onDescriptionChange} />
                        </>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-link p-0"
                            disabled={disabled}
                            onClick={onShowDescription}
                        >
                            {t('btnAddInfo')}
                        </button>
                    )}
                </Form.Group>
            )}
        </>
    );
};

export default ProcessRunGeneralFields;
